import type { ComponentType } from "react";
import type { ToolPart } from "../../types";
import { DefaultToolCard } from "./DefaultToolCard";
import { TodoCard } from "./TodoCard";
import { QuestionCard } from "./QuestionCard";
import { CalculatorCard } from "./CalculatorCard";
import { MailComposeCard } from "./MailComposeCard";
import { SkillCard } from "./SkillCard";
import { CanvasCard } from "./CanvasCard";
import { CanvasReadCard } from "./CanvasReadCard";
import { InfographicCard } from "./InfographicCard";
import { PythonRunCard } from "./PythonRunCard";

export type ToolRenderer = ComponentType<{ part: ToolPart }>;

export const TOOL_RENDERERS: Record<string, ToolRenderer> = {
  todowrite: TodoCard,
  question: QuestionCard,
  calculator: CalculatorCard,
  compose_email: MailComposeCard,
  skills: SkillCard,
  canvas_write: CanvasCard,
  canvas_read: CanvasReadCard,
  // `email_draft_read` is a silent lookup — same reasoning as canvas_read.
  email_draft_read: CanvasReadCard,
  render_infographic: InfographicCard,
  python_run: PythonRunCard,
};

export function ToolCallRenderer({ part }: { part: ToolPart }) {
  const Renderer = TOOL_RENDERERS[part.tool] ?? DefaultToolCard;
  return <Renderer part={part} />;
}
